<template>
  <div class="flex flex-row gap-2 items-center justify-start px-3 proxima_nova">
    <span class="text-sm text_color">{{ row.currency_name || row.currency }}</span>
    <span
      v-if="row.is_primary"
      class="primary_tag text-sm font-semibold text_color"
    >
      Primary
    </span>
  </div>
</template>

<script setup>
defineProps({
  row: {
    type: Object,
    required: true,
    default: () => ({}),
  },
});
</script>

<style scoped>
.primary_tag {
    padding: 4px 8px;
    border-radius: 16px;
    border: 1px solid var(--white-opacity-8 );
    background: var(--white-opacity-8 );
}
</style>

